import { systemEngineEnvironment } from "services/environment/systemEngine";

import { ServiceAccount, ServiceAccountSecret } from "./types";

export const createSecret = async (serviceAccount: ServiceAccount) => {
  const result = await systemEngineEnvironment.execute<ServiceAccountSecret>(
    `CALL fb_generateServiceAccountKey('${serviceAccount.serviceAccountName}')`
  );
  const [response] = result;
  const [row] = response.rows;
  return row.secret;
};
